import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  signupForm: FormGroup;
  forbiddenProjectName = 'test';
  fullname: string = '';
  collapsed = true;
  language: string;


  constructor(@Inject(DOCUMENT) public document: Document) { }


  ngOnInit() {

    this.signupForm = new FormGroup({
      'fullname': new FormControl(null, Validators.required),
      'mail': new FormControl(null, [Validators.required, Validators.email]),
      'phone': new FormControl(null, Validators.required),
      'address': new FormControl(null, Validators.required)
    });



  }

  onSubmit() {
    console.log(this.signupForm.value);

  }


}
